import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import Courses from './pages/Courses/Courses';
import About from './pages/About/About';
import NavCom from './components/navBar/nav';
import FooterCom from './components/footer/footer';
import Contact from './pages/Contact/Contact';
import ScrollToTop from './components/scrolltowindow';
import Australia from './pages/Study Abroad/Australia/australia';
import Canada from './pages/Study Abroad/Canada/canada';
import UnitedKingdom from './pages/Study Abroad/Uk/uk';
import NewZealand from './pages/Study Abroad/New Zealand/newzealand';

function App() {
  return (
    <div>
      <ScrollToTop />
      <NavCom />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/courses' element={<Courses />} />
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/australia' element={<Australia />} />
        <Route path='/canada' element={<Canada />} />
        <Route path='/uk' element={<UnitedKingdom />} />
        <Route path='/nz' element={<NewZealand />} />
      </Routes>
      <FooterCom />
    </div>
  );
}

export default App;
